import { useState, useCallback } from 'react';
import ExportAPI from 'services/API/ExportAPI';

export const useCompanyCsvExport = (id: string) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ExportAPI.getCompanyCsvExport(id);
      const url = response?.data?.url;
      setData(url);
      if (url) {
        window.open(url, '_blank');
      }
      setLoading(false);
    } catch (err: any) {
      setError(err);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, loading, error, fetchData };
};
